import adminAxiosInstance from "./api/adminAxiosInstance";

const searchSimulations = async (filters) => {
  // filters: { name, minAmount, maxAmount, startDate, endDate, page, pageSize }
  const params = new URLSearchParams();

  if (filters.name) params.append("name", filters.name);
  if (filters.minAmount) params.append("minAmount", filters.minAmount);
  if (filters.maxAmount) params.append("maxAmount", filters.maxAmount);
  if (filters.startDate) params.append("startDate", filters.startDate);
  if (filters.endDate) params.append("endDate", filters.endDate);
  if (filters.page) params.append("page", filters.page);
  if (filters.pageSize) params.append("pageSize", filters.pageSize);

  const response = await adminAxiosInstance.get(
    `simulation/search?${params.toString()}`
  );
  return response.data;
};

export const simulationService = {
  searchSimulations,
};
